/*[2/24/22, PC_SH_04, Priyanka D]*/
import React, { Component } from 'react';
import * as ShippingAction from '../actions/ShippingAction';
import ShippingStore from '../stores/ShippingStore';
import NonCatalogStore from '../stores/NonCatalogStore';
import * as $ from 'jquery';
/* PC_CPW_313_01, Yuvarani K */
import Copy from 'copy-to-clipboard';
import * as CookieService from '../CookieService';
//import ReactPaginate from 'react-paginate';
//import ReactToPrint from 'react-to-print';
//import QRCode from 'react-qr-code';
//import Barcode from 'react-barcode';
//import ZplImage from 'zpl-image';
//import ZPLLabel from 'labelary';
//import LabelZPL from 'zpl-label-designer';
import SDIConstants from '../SDIConstants';
import Select from 'react-select';
import { withTranslation, Trans } from 'react-i18next'
import * as MenuAction from '../actions/MenuAction';
import swal from 'sweetalert';
import * as NonCatalogAction from '../actions/NonCatalogAction';
import objShopRedirectStore from '../stores/ShopRedirectStore';
//import CatchBuster from 'react-cache-buster';

//import { Svg } from '@react-pdf/renderer';
//import qs from 'qs';
//import axios from 'axios';
let currentPagePath;
/*PC_CPW_313_02, Yuvarani K */
let containerOption = [];

class ShippingComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            OrderOptions: [],
            PackageOptions: [],
            OrderValue: "",
            OrderName: "",
            PackageValue: "",
            PackageName: "",
            RecipientDesc: "",
            RecipientAddress: "",
            RecipientName: "",
            ShipperName: "",
            RecipientContactNo: "",
            ShipperCompname: "",
            RecipientStreet1: "",
            RecipientStreet2: "",
            RecipientStreet3: "",
            RecipientCity: "",
            RecipientPostalCode: "",
            RecipientState: "",
            ShowDescAddress: false,
            OrderArray: [],
            ServiceTypeArray: [],
            ShippingType: "",
            ShippingArray: [],
            PickUpType: "",
            PickUpArray: [],
            MainFedexGrid: [],
            ShippContDet: [],
            HDRPackArray: [],
            HDRPackType: "",
            TrackNumb: "",
            pdfUrl: "",
            SubPackageOptions: [],
            PackageArray: [],
            ServiceArray: [],
            DeliveryInstructions: "",
            hasRecipientInfo: false,
            PrinterValue: "",
            PrinterOptions: [],
            IsReprintTab: false,
            ReprintOrderArray: [],
            ReprintOrderOptions: [],
            ReprintOrderValue: "",
            ReprintEncodedLabel: "",
            ReprintTrackingNum: "",
            PrintingShipType: "",
            ListOfPackUrls: [],
            SelectedreprintOrder: "",
            ReprintUrls: [],
            CribName: "",
            BOLPrinterOptions: [],
            ISBOLPrinting: false,
            BOLPrinterValue: "",
            FreightBOLUrl: "",
            OrderLineDetails: [],
            displayAttachmentArr: [],
            attachmentArr: [],
            orderArr: [],
            hideDuplicateMsg: true,
            selectedContainer: "",
            questionCount: 0,
            hideOnlyImgMsg: true,
            selectedContainerIndex: null,
            PikClicksArr: [],
            /*PC_CPW_313_03, PC_CPW_313_04, PC_CPW_313_05, Yuvarani K */
            ReprintcontainerOptions: [],
            ReprintTrackingNo: "",
            isSuccess: false,
            containerArray: [],
            UpdateResponse: false,
            FilteredOrders: [],
            TrackingArray: [],
            //CPW-327 Redirecting to Fedex panel - Nandhini L
            OrderSelected: false,
            ConOrderNo: this.props.location.state && this.props.location.state.OrderNo != undefined && this.props.location.state.OrderNo != null && this.props.location.state.OrderNo != "" ? this.props.location.state.OrderNo : "",
            isFromCon: this.props.location.state && this.props.location.state.OrderNo != undefined && this.props.location.state.OrderNo != null && this.props.location.state.OrderNo != "" ? true : false,
            isFright: "",
            BolDefaultCheck: false,
            DefaultCheck: false
        }
    }
    componentDidMount() {

        //debugger
        /* PC_CPW_313_06, Yuvarani K */
        $("#SuccessPop").hide();
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');

        /*[2/24/22, PC_SH_05, Priyanka D]*/
        CookieService.updateLocalStorageValues("Session_PageName", window.location.pathname);
        //this.GetAccessToken();
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');

        currentPagePath = this.props.location.pathname;
        currentPagePath = currentPagePath.indexOf("?") >= 0 ? currentPagePath.split("?")[0] : currentPagePath;
        let getFavPageBO = {
            Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
            pageURL: currentPagePath.toLowerCase(),
            Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT")
        };
        ShippingAction.getCurrentFavPage(getFavPageBO);
        this.PageLoad("1");

        /*[2/24/22, PC_SH_21, Priyanka D]*/
        ShippingStore.on('AccesstokenRes', this.AccessTokenResponse);
        ShippingStore.on('RecipientData', this.PageLoadResponse);
        ShippingStore.on('SubmitClickData', this.SubmitClickResponse);
        ShippingStore.on('UpdatetrackNum', this.UpdateTrackNumRespnse);
        ShippingStore.on('PrintLabel', this.PrintRespnse);
        ShippingStore.on('WeighingScale', this.WeighingScaleResponse);
        NonCatalogStore.on('NONCAT_UploadAttachmentsFedEx', this.tempAttachResponse);
        ShippingStore.on('favpage', this.loadFavPageResponse.bind(this));
        ShippingStore.on('updateFavPage', this.updateFavPageResponse.bind(this));

    }
    componentWillUnmount() {
        ShippingStore.removeListener('favpage', this.loadFavPageResponse.bind(this));
        ShippingStore.removeListener('updateFavPage', this.updateFavPageResponse.bind(this));
        ShippingStore.removeListener('AccesstokenRes', this.AccessTokenResponse);
        ShippingStore.removeListener('RecipientData', this.PageLoadResponse);
        ShippingStore.removeListener('SubmitClickData', this.SubmitClickResponse);
        ShippingStore.removeListener('UpdatetrackNum', this.UpdateTrackNumRespnse);
        ShippingStore.removeListener('PrintLabel', this.PrintRespnse);
        NonCatalogStore.removeListener('NONCAT_UploadAttachmentsFedEx', this.tempAttachResponse);
    }
    loadFavPageResponse = () => {
        let favPageResponse = JSON.parse(ShippingStore.currentFavPageResponse);
        if (favPageResponse.length > 0) {
            favPageResponse = favPageResponse[0];
            this.setState({ isFavorited: true, Page_ID: favPageResponse.PAGE_ID });
        };
    };
    updateFavPageResponse = () => {
        if (ShippingStore.updateFavPageResponse.updateType == 1) {
            let response = JSON.parse(ShippingStore.updateFavPageResponse.responseStr)[0];
            if (response.is_Success == "True") {
                $(`#${SDIConstants.SDILoader}`).addClass('hide');
                this.setState({ isFavorited: true, Page_ID: response.Page_ID });
                MenuAction.toastMessage(1);
            }
        } else {
            let response = JSON.parse(ShippingStore.updateFavPageResponse.responseStr)[0];
            if (response.success == "true") {
                $(`#${SDIConstants.SDILoader}`).addClass('hide');
                this.setState({ isFavorited: false });
                MenuAction.toastMessage(2);
            }
        }

    };
    handleFavorite = (event) => {
        this.setState({ isFavorited: event.target.checked });
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        if (event.target.checked == true) {
            let insertFavPageBO = {

                Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
                pageURL: currentPagePath.toLowerCase(),
                pageTitle: "FedEx Shipping",
                Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT")
            }
            ShippingAction.insertFavPage(insertFavPageBO)
        } else {
            let deleteFavPageBO = {
                Page_ID: this.state.Page_ID
            }
            ShippingAction.deleteFavPage(deleteFavPageBO)
        }
    };


    displayPopUp = (index) => {
        let tempSelectedContainer = this.state.orderArr[index].SHIP_CNTR_ID
        let tempAttachmentArr = this.state.attachmentArr.filter((x) => x.containerId == tempSelectedContainer)
        this.setState({ displayAttachmentArr: tempAttachmentArr, selectedContainer: tempSelectedContainer, questionCount: tempAttachmentArr.length, selectedContainerIndex: index })
        $('#addattachment').modal('show');
    }
    onInputClick = (event) => {
        event.target.value = ''
    }
    removeMultiImage = () => {
        let deleteImg = []
        this.state.displayAttachmentArr.map((value, index) => {
            this.state.attachmentArr.map((value1, index1) => {
                if (this.state.displayAttachmentArr[index] == this.state.attachmentArr[index1]) {
                    deleteImg.push(this.state.displayAttachmentArr[index].filePath)
                }
            })
        })
        let Obj = {
            deleteAttachArr: deleteImg
        }
        $('#addattachment').modal('hide');
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        this.setState({ hideDuplicateMsg: true, hideOnlyImgMsg: true })
        ShippingAction.deleteMultiAttach(Obj)

    }
    tempAttach = (event, index) => {

        let files = event.target.files;
        let filetype = files[0].type;
        if (!(filetype.toLowerCase().includes('jpg') || (filetype.toLowerCase().includes('png')) || (filetype.toLowerCase().includes('jpeg')) || (filetype.toLowerCase().includes('pdf')))) {
            this.setState({ hideOnlyImgMsg: false, hideDuplicateMsg: true })
            return;
        }
        let fileIndex = this.state.displayAttachmentArr.findIndex(file => file.fileName === event.target.files[0].name)
        if (fileIndex >= 0) {
            this.setState({ hideDuplicateMsg: false })
        }
        else {
            $(`#${SDIConstants.SDILoader}`).removeClass('hide');
            NonCatalogAction.addFedExImages(event.target.files);
            this.setState({ hideDuplicateMsg: true })
        }

    }
    tempAttachResponse = () => {
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        let tempDisplayAttachmentArr = this.state.displayAttachmentArr
        let isValid = NonCatalogStore.attachmentResponse.indexOf("You have exceeded the length of total file names") >= 0 ? false : true;
        if (isValid) {
            let attachmentResponse = JSON.parse(NonCatalogStore.attachmentResponse);
            if (attachmentResponse && attachmentResponse.length > 0) {
                let Obj = {
                    containerId: this.state.selectedContainer,
                    fileName: attachmentResponse[0].FileName,
                    filePath: attachmentResponse[0].FilePath,
                };
                tempDisplayAttachmentArr.push(Obj)
            }
        }
        else {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: NonCatalogStore.attachmentResponse
            });
        }
        this.setState({ displayAttachmentArr: tempDisplayAttachmentArr, questionCount: tempDisplayAttachmentArr.length, hideOnlyImgMsg: true })
    }
    addAttachment = () => {
        let tempAttachmentArr = this.state.attachmentArr
        let tempDisplayAttachmentArr = this.state.displayAttachmentArr
        tempAttachmentArr = tempAttachmentArr.filter(value => value.containerId !== this.state.selectedContainer);
        if (tempDisplayAttachmentArr.length > 0) {
            document.getElementById(`AttachError${this.state.selectedContainerIndex}`).innerText = ""
        }
        tempDisplayAttachmentArr.map((value, index) => {
            tempAttachmentArr.push(value)
        })
        let tempPikClicksArr = this.state.PikClicksArr
        tempPikClicksArr[this.state.selectedContainerIndex] = tempDisplayAttachmentArr.length
        this.setState({ attachmentArr: tempAttachmentArr, hideDuplicateMsg: true, hideOnlyImgMsg: true, PikClicksArr: tempPikClicksArr })
        $('#addattachment').modal('hide');
    }
    downloadAttachment = (e, attachment) => {
        e.preventDefault();
        let downloadBO = {
            fileName: attachment.fileName,
            filePath: attachment.filePath
        }
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        NonCatalogAction.downloadAttachment(downloadBO);
    };
    removeAttachments = (filepath, index) => {
        let tempDisplayAttachmentArr = this.state.displayAttachmentArr
        tempDisplayAttachmentArr.splice(index, 1)
        this.setState({ displayAttachmentArr: tempDisplayAttachmentArr, questionCount: tempDisplayAttachmentArr.length })
    }

    bindAttachments = () => {
        if (this.state.displayAttachmentArr != null && this.state.displayAttachmentArr != undefined) {
            if (this.state.displayAttachmentArr.length > 0) {
                return this.state.displayAttachmentArr.map((attachment, index) => {
                    return (
                        <div className="attachment-file-name mt-2 col-md-4 p-0" key={index}>
                            <a href="#" className="noncat-Attachment-overflow" onClick={(e) => this.downloadAttachment(e, attachment)} data-toggle="tooltip" title={attachment.fileName}>{attachment.fileName.length < 15 ? attachment.fileName : attachment.fileName.slice(0, 11) + "..."}</a>
                            <span className="attachment-remove-icon ml-1" onClick={() => this.removeAttachments(attachment.FilePath, index)}>X  </span>
                        </div>
                    );
                });
            }
        }
    };


    WeighingScaleResponse = () => {
        //debugger
        let LocData = ShippingStore.WeighingScale;
        swal({
            allowOutsideClick: false,
            closeOnClickOutside: false,
            text: LocData
        });
        //  alert(LocData);
    }
    GetWeight = () => {
        //debugger
        let RecipientBO = {
            Session_BusUnit: CookieService.getLocalStorageValues("Session_BUSUNIT"),
            Session_UserID: CookieService.getLocalStorageValues("Session_UserID")
        };
        //ShippingAction.GetWeight(RecipientBO);
    }

    GetAccessToken = () => {
        debugger;
        let SerType;
        let ShipType;
        let HDRpack;
        let picktype;
        SerType = this.state.ServiceValue.value;
        ShipType = this.state.ShippingType.value;
        HDRpack = this.state.HDRPackType.value;
        picktype = this.state.PickUpType.value;
        let IsValid = false;
        if (this.state.ServiceValue == "" || this.state.ServiceValue == {}) {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: 'Please select service type'
            });
            // alert('Please Select Service Type');
            return;
        }
        if (this.state.HDRPackType == "" || this.state.HDRPackType == {}) {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: 'Please select order level package type'
            });
            //alert('Please Select Order Level Package Type');
            return;
        }
        if (this.state.PickUpType == "" || this.state.PickUpType == {}) {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: 'Please select pick up type'
            });
            //alert('Please Select Pick Up Type');
            return;
        }
        if (this.state.OrderValue == "" || this.state.OrderValue == {}) {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: 'Please select an order to process shipment'
            });
            //  alert('Please Select An Order To Process Shipment');
            return;
        }
        if (this.state.RecipientName == "") {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: 'Please enter recipient name'
            });
            //   alert('Please Enter Recipient Name');
            return;
        }
        if (this.state.RecipientContactNo == "") {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: 'Please enter recipient contact number'
            });
            // alert('Please Enter Recipient Contact Number');
            return;
        }
        if (this.state.DeliveryInstructions == "" && (this.state.ShippingType.value == "FedExLTL" || this.state.ShippingType == "FedExLTL")) {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: 'Please enter delivery instructions'
            });
            //   alert('Please Enter Delivery Instructions');
            return;
        }
        else {

            if (this.state.RecipientContactNo.length > 10) {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: 'Contact number cannot be greater than 10'
                });
                //  alert('Contact Number Cannot Be Greater Than 10');
                return;
            }
            else if (this.state.RecipientContactNo.length < 10) {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: 'Contact number cannot be less than 10'
                });
                //  alert('Contact Number Cannot Be Less Than 10');
                return;
            }
            else if (this.state.RecipientContactNo == "0000000000") {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: "The whole contact number should not be with 0's"
                });
                //  alert("The Whole Contact Number Should Not Be With 0's");
                return;
            }
        }
        let count = 0;
        this.state.orderArr.forEach((val, index) => {
            IsValid = false;
            let packlab;

            if (this.state.MainFedexGrid[index].PackageValue != undefined) {
                packlab = this.state.MainFedexGrid[index].PackageValue.value;
            }
            let weight = this.state.MainFedexGrid[index].Weight;
            let alertmsg;
            if (packlab == "" || packlab == undefined || this.state.MainFedexGrid[index].PackageValue == undefined) {

                alertmsg = "Please select package type for line no " + (index + 1);
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: alertmsg
                });
                // alert(alertmsg);
                IsValid = true;
                count += 1;
                return false;
            }
            if (weight == "0" || weight == "") {
                alertmsg = "Please enter weight for line no " + (index + 1);
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: alertmsg
                });
                //  alert(alertmsg);
                IsValid = true;
                count += 1;
                return false;
            }
        })
        if (count > 0) {
            return false;
        }
        else {
            let noImgForFragile = 0
            this.state.orderArr.map((value, index) => {
                if (value.PACKING_CD != undefined) {
                    if (value.PACKING_CD.toLowerCase().trim() != null && value.PACKING_CD.toLowerCase().trim() != "") {
                        let fragileIndex = this.state.attachmentArr.findIndex(container => container.containerId == value.SHIP_CNTR_ID)
                        if (fragileIndex < 0) {
                            document.getElementById(`AttachError${index}`).innerText = "Please upload image"
                            noImgForFragile = noImgForFragile + 1
                        }
                    }
                }
            })
            if (noImgForFragile == 0) {
                let accesstokenObj = {
                    ShipmentType: this.state.ShippingType.value
                }
                $(`#${SDIConstants.SDILoader}`).removeClass('hide');
                ShippingAction.AccesstokenRes(accesstokenObj);
            }
        }

    }
    AccessTokenResponse = () => {
        //debugger;
        let LocData = JSON.parse(ShippingStore.AccesstokenRes);
        if (LocData == "") {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "There is an error in generating access token"
            });
            $(`#${SDIConstants.SDILoader}`).addClass('hide');
        }
        else {
            let b = JSON.parse(LocData);
            //let c = JSON.parse(b);
            $(`#${SDIConstants.SDILoader}`).addClass('hide');
            let accesstoken = b.access_token;
            //let accessto = c.access_token;
            //this.PageLoad();
            if (accesstoken != undefined && accesstoken != null & accesstoken != "") {
                this.SubmitClick(accesstoken);
                this.setState({ AccessToken: accesstoken })
            }
        }
    }
    PageLoad = (type) => {
        //debugger;
        // $(`#${SDIConstants.SDILoader}`).addClass('hide');
        /* PC_CPW_313_07, Yuvarani K*/
        this.setState({
            ReprintcontainerOptions: [], ReprintOrderValue: "", ReprintTrackingNo: ""
        })
        // ShippingAction.getAccessToken();
        let IsReprint = false;
        if (type == "2") {
            IsReprint = true;
        }
        this.setState({
            IsReprintTab: IsReprint
        });
        let cribID = CookieService.getLocalStorageValues("Session_ISA_CRIB_IDENT");
        console.log("DeepthiConsole", CookieService.getLocalStorageValues("Session_ISA_CRIB_IDENT"));
        if (CookieService.getLocalStorageValues("Session_ISA_CRIB_IDENT") == null || CookieService.getLocalStorageValues("Session_ISA_CRIB_IDENT") == undefined ||
            CookieService.getLocalStorageValues("Session_ISA_CRIB_IDENT") == "" || CookieService.getLocalStorageValues("Session_ISA_CRIB_IDENT") == " ") {
            cribID = CookieService.getLocalStorageValues("Session_ISA_CRIB_IDENT");
            if (CookieService.getLocalStorageValues("HideMobility") && CookieService.getLocalStorageValues("HideMobility").toUpperCase() == "TRUE") {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: "No crib has been selected. Please contact the admin/manager to assign a crib"
                });
                this.props.history.push({
                    pathname: `/homepage`
                });
            }
            else {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: "Please select crib from user profile"
                });
                this.props.history.push({
                    pathname: `/profile`,
                    state: { origin: 'Inventory' }
                });
            }
            return;
        }
        else {
            let RecipientBO = {
                Session_BusUnit: CookieService.getLocalStorageValues("Session_BUSUNIT"),
                Session_UserID: CookieService.getLocalStorageValues("Session_UserID"),
                Session_Crib: CookieService.getLocalStorageValues("Session_ISA_CRIB_IDENT")
            };
            $(`#${SDIConstants.SDILoader}`).removeClass('hide');
            ShippingAction.GetRecipientDet(RecipientBO);

        }

    }
    PageLoadResponse = () => {
        //debugger
        let PageloadData = JSON.parse(ShippingStore.RecipientData);
        let OrderDetailArray = PageloadData.PageloadDetails;
        let RecipentArray = PageloadData.PackageTypeDt;
        let ServiceType = PageloadData.ServiceTypeDt;
        let contactdet = PageloadData.ContactDetailsDt;
        let cribName = "";
        if (OrderDetailArray != undefined) {
            if (OrderDetailArray.length > 0) {
                cribName = OrderDetailArray[0].CRIBNAME;
            }
        }
        this.setState({ ShippContDet: contactdet, PackageArray: RecipentArray, ServiceArray: ServiceType, CribName: cribName });
        //ShippingAction.JSPrint("");
        this.BindOrderNumber(OrderDetailArray);
        //this.BindPackageType(RecipentArray);
        //this.BindServiceType(ServiceType);
        let ReprintOrders = PageloadData.ReprintOrdersDT;
        this.bindReprintOrders(ReprintOrders)
        let PrinterNames = PageloadData.PrinterNameDT;
        this.BindShippingType();
        this.BindPickUpType();
        this.BindPrinterTypes(PrinterNames[0].PrinterName, cribName);
        //let locMainFedexGrid = [];
        //let locobj = {
        //    packagetypearray: this.state.PackageOptions,
        //    Weight: "", 
        //    Units: "LB",
        //    IsDelete: false,
        //    PackageValue: "",
        //}
        //locMainFedexGrid.push(locobj);
        //CPW-89 FedEx LTL - Deepthi N H
        $(`#${SDIConstants.SDILoader}`).addClass('hide');


    }
    AddRowClick = () => {
        //debugger
        let locMainFedexGrid = this.state.MainFedexGrid;
        locMainFedexGrid = [];
        let localArray = {
            value: "YOUR_PACKAGING",
            label: "Customer Packaging"
        }
        let locobj;
        this.state.orderArr.map((value, item) => {
            if (this.state.isFright == "false" || this.state.ShippingType.value == "FedEx") {
                if (this.state.isFright == "") {
                    locobj = {
                        packagetypearray: this.state.SubPackageOptions,
                        Weight: "",
                        Units: "LB",
                        IsDelete: false,
                        PackageValue: "",
                    }

                }
                else {
                    locobj = {
                        packagetypearray: this.state.SubPackageOptions,
                        Weight: "",
                        Units: "LB",
                        IsDelete: false,
                        PackageValue: localArray,
                    }

                }
                locMainFedexGrid.push(locobj);
            }
            else {
                let SubPack = [{ "value": "BAG", "label": "BAG" }, { "value": "BARREL", "label": "BARREL" }, { "value": "BASKET", "label": "BASKET" }, { "value": "BOX", "label": "BOX" },
                { "value": "BUCKET", "label": "BUCKET" }, { "value": "BUNDLE", "label": "BUNDLE" }, { "value": "CAGE", "label": "CAGE" }, { "value": "CARTON", "label": "CARTON" }, { "value": "CASE", "label": "CASE" },
                { "value": "CHEST", "label": "CHEST" }, { "value": "CONTAINER", "label": "CONTAINER" }, { "value": "CRATE", "label": "CRATE" }, { "value": "CYLINDER", "label": "CYLINDER" }, { "value": "DRUM", "label": "DRUM" },
                { "value": "ENVELOPE", "label": "ENVELOPE" }, { "value": "HAMPER", "label": "HAMPER" }, { "value": "OTHER", "label": "OTHER" }, { "value": "PACKAGE", "label": "PACKAGE" }, { "value": "PAIL", "label": "PAIL" },
                { "value": "PALLET", "label": "PALLET" }, { "value": "PARCEL", "label": "PARCEL" }, { "value": "PIECE", "label": "PIECE" }, { "value": "REEL", "label": "REEL" }, { "value": "ROLL", "label": "ROLL" }, { "value": "SACK", "label": "SACK" },
                { "value": "SHRINKWRAPPED", "label": "SHRINKWRAPPED" }, { "value": "SKID", "label": "SKID" }, { "value": "TANK", "label": "TANK" }, { "value": "TOTEBIN", "label": "TOTEBIN" }, { "value": "TUBE", "label": "TUBE" }, { "value": "UNIT", "label": "UNIT" }];
                if (this.state.isFright == "") {
                    locobj = {
                        packagetypearray: SubPack,
                        Weight: "",
                        Units: "LB",
                        IsDelete: false,
                        PackageValue: "",
                    }
                }
                else {
                    locobj = {
                        packagetypearray: SubPack,
                        Weight: "",
                        Units: "LB",
                        IsDelete: false,
                        PackageValue: SubPack[19],
                    }
                }
                locMainFedexGrid.push(locobj);
            }
        })

        this.setState({ MainFedexGrid: locMainFedexGrid })

    }
    DeleteRowClick = (e, index) => {
        //debugger
        let { MainFedexGrid } = this.state;
        if (MainFedexGrid.length <= 1) {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Package Details for atleast one Item should be filled"
            });
            // alert("Package Details for atleast one Item should be filled");
        }
        else {
            MainFedexGrid.splice(index, 1);
        }
        this.setState(
            { MainFedexGrid: MainFedexGrid });
    }
    SubmitClick = (accesstoken) => {
        //debugger
        let locarray = this.state.MainFedexGrid;
        let Workorder = "";
        if (this.state.ShippContDet != undefined) {
            if (this.state.ShippContDet.length > 0) {
                let phonenum = this.state.ShippContDet[0].PHONE;
                phonenum = phonenum.replaceAll("/", "");
                phonenum = phonenum.replaceAll("-", "");
                let street = this.state.ShippContDet[0].ADDRESS2;
                let street1 = "", street2 = "", street3 = "";
                let ShipperStreetLines = [], RecStreetLines = [];
                if (street.length > 30) {
                    let SpaceSplit = street.split(" ");
                    if (SpaceSplit.length > 0) {
                        let concatstreet1 = "", concatstreet2 = "";
                        SpaceSplit.forEach((x, ind) => {
                            if (ind == 0) {
                                concatstreet1 = x;
                                street1 = x;
                            }
                            else {
                                concatstreet1 = street1 + " " + x;
                                if (street2 == "") {
                                    concatstreet2 = x;
                                } else {
                                    concatstreet2 = street2 + " " + x;
                                }
                                if (concatstreet1.length <= 30) {
                                    street1 += " " + x;
                                }
                                else if (concatstreet2.length <= 30) {
                                    if (street2 == "") {
                                        street2 = x;
                                    } else {
                                        street2 = street2 + " " + x;
                                    }
                                }
                                else {
                                    if (street3 == "") {
                                        street3 = x;
                                    }
                                    else {
                                        street3 += " " + x;
                                    }

                                }
                                concatstreet1 = "";
                                concatstreet2 = "";
                            }

                        })
                    }
                    ShipperStreetLines.push(street1);
                    if (street2.length > 0) {
                        ShipperStreetLines.push(street2);
                    }
                    if (street3.length > 0) {
                        ShipperStreetLines.push(street3);
                    }
                }
                else {
                    street1 = street;
                    ShipperStreetLines.push(street1);
                }

                let city = this.state.ShippContDet[0].CITY;
                let state = this.state.ShippContDet[0].STATE;
                let postalcode = this.state.ShippContDet[0].POSTAL;
                let ShipperAddress = this.state.ShippContDet[0].ADDRESS1;
                let SerType;
                let ShipType;
                let HDRpack;
                let picktype;

                SerType = this.state.ServiceValue.value;
                ShipType = this.state.ShippingType.value;
                HDRpack = this.state.HDRPackType.value;
                picktype = this.state.PickUpType.value;

                let PackageLineItems = [];
                let freightlineItems = [];
                let reqfreightlineitems = [];
                let shiptype = this.state.ShippingType.value;
                let ShippingPayload;
                let lineitemscount = locarray.length;
                let OrderDetails = this.state.OrderArray;
                let RecStreet = this.state.RecipientStreet2;
                if (this.state.RecipientStreet3 != "") {
                    RecStreet = this.state.RecipientStreet2 + " " + this.state.RecipientStreet3;
                }
                let RecStreet1 = "", RecStreet2 = "", RecStreet3 = "";
                if (RecStreet.length > 30) {
                    let RecSpaceSplit = RecStreet.split(" ");
                    if (RecSpaceSplit.length > 0) {
                        let concatstreet1 = "", concatstreet2 = "";
                        RecSpaceSplit.forEach((x, ind) => {
                            if (ind == 0) {
                                concatstreet1 = x;
                                RecStreet1 = x;
                            }
                            else {
                                concatstreet1 = RecStreet1 + " " + x;
                                if (RecStreet2 == "") {
                                    concatstreet2 = x;
                                } else {
                                    concatstreet2 = RecStreet2 + " " + x;
                                }
                                if (concatstreet1.length <= 30) {
                                    RecStreet1 += " " + x;
                                }
                                else if (concatstreet2.length <= 30) {
                                    if (RecStreet2 == "") {
                                        RecStreet2 = x;
                                    } else {
                                        RecStreet2 += " " + x;
                                    }
                                }
                                else {
                                    if (RecStreet3 == "") {
                                        RecStreet3 = x;
                                    }
                                    else {
                                        RecStreet3 += " " + x;
                                    }

                                }
                                concatstreet1 = "";
                                concatstreet2 = "";
                            }

                        })
                    }
                    RecStreetLines.push(RecStreet1);
                    if (RecStreet2.length > 0) {
                        RecStreetLines.push(RecStreet2);
                    }
                    if (RecStreet3.length > 0) {
                        RecStreetLines.push(RecStreet3);
                    }
                }
                else {
                    RecStreet1 = RecStreet;
                    RecStreetLines.push(RecStreet1);
                }

                if (shiptype == "FedEx") {
                    locarray.forEach((val, index) => {
                        let packlab = val.PackageValue.value;
                        let weightobj = {
                            value: val.Weight,
                            units: "LB"
                        }
                        let lineItems = {
                            weight: weightobj,
                            packagingType: packlab
                        }

                        PackageLineItems.push(lineItems);
                    })
                }
                else {
                    locarray.forEach((val, index) => {
                        let hazardousCode = "";
                        let lineIndex = OrderDetails.findIndex(elem => elem.ORDER_NO === this.state.OrderValue.value);
                        let lineDet = OrderDetails[lineIndex];
                        let ContainerID = this.state.orderArr[index].SHIP_CNTR_ID
                        let Desc254 = []
                        let ContainerRecords = this.state.FilteredOrders.filter((x) => x.SHIP_CNTR_ID == ContainerID)

                        ContainerRecords.forEach(order => {
                            // Only add DESC254 if it's not already in the array for that SHIP_CNTR_ID
                            if (!Desc254.includes(order.DESCR254)) {
                                Desc254.push(order.DESCR254);
                            }
                        });
                        // Build the final string directly, separated by commas
                        let finalString = Desc254.join(',');
                        Workorder = `${lineDet.ORDER_NO} ${'- '}${lineDet.ISA_WORK_ORDER_NO} `;

                        if (lineDet.HazDesc1 != undefined && lineDet.Desc200 != undefined) {
                            if (lineDet.HazDesc1 != null) {
                                hazardousCode = lineDet.HazDesc1;
                            }
                            if (lineDet.Desc200 != null) {
                                hazardousCode = lineDet.Desc200;
                            }
                        }
                        let packlab = val.PackageValue.value;
                        let weightobj = {
                            value: val.Weight,
                            units: "LB"
                        }
                        if (hazardousCode != "") {
                            hazardousCode = "(" + hazardousCode + ")";
                        }
                        let lineItems = {
                            weight: weightobj,
                            pieces: 1,
                            handlingUnits: index + 1,
                            subPackagingType: packlab,
                            description: finalString + hazardousCode,
                            id: index + 1
                        }
                        let asslineItemarray = [];
                        let assobj = {
                            id: index + 1
                        }
                        asslineItemarray.push(assobj)
                        let reqlineItems = {
                            weight: weightobj,
                            subPackagingType: packlab,
                            associatedFreightLineItems: asslineItemarray
                        }
                        reqfreightlineitems.push(reqlineItems);
                        freightlineItems.push(lineItems);
                    })
                }
                if (shiptype == "FedEx") {
                    ShippingPayload = {
                        "labelResponseOptions": "LABEL",
                        "requestedShipment": {
                            "shipper": {
                                "contact": {
                                    "personName": CookieService.getLocalStorageValues("Session_UserID"),
                                    "phoneNumber": phonenum
                                },
                                "address": {
                                    "streetLines": ShipperStreetLines,
                                    "city": city,
                                    "stateOrProvinceCode": state,
                                    "postalCode": postalcode,
                                    "countryCode": "US"
                                }
                            },
                            "recipients": [
                                {
                                    "contact": {
                                        "personName": this.state.RecipientName,
                                        "phoneNumber": this.state.RecipientContactNo
                                    },
                                    "address": {
                                        "streetLines": RecStreetLines,
                                        "city": this.state.RecipientCity,
                                        "stateOrProvinceCode": this.state.RecipientState,
                                        "postalCode": this.state.RecipientPostalCode,
                                        "countryCode": "US"
                                    }
                                }
                            ],
                            "serviceType": SerType,
                            "packagingType": HDRpack,
                            "pickupType": picktype,
                            "blockInsightVisibility": false,
                            "shippingChargesPayment": {
                                "paymentType": "SENDER"
                            },
                            "labelSpecification": {
                                "imageType": "ZPLII",
                                "labelStockType": "STOCK_4X6"
                            },
                            "requestedPackageLineItems": PackageLineItems
                        },
                        "accountNumber": {
                            "value": ""
                        }
                    }
                }
                else {
                    ShippingPayload = {
                        "labelResponseOptions": "URL_ONLY",
                        "freightRequestedShipment": {
                            "shipper": {
                                "address": {
                                    "streetLines": ShipperStreetLines,
                                    "city": city,
                                    "stateOrProvinceCode": state,
                                    "postalCode": postalcode,
                                    "countryCode": "US"
                                },
                                "contact": {
                                    "personName": this.state.ShipperName,
                                    "phoneNumber": phonenum,
                                    "companyName": ShipperAddress
                                }
                            },
                            "recipient": {
                                "address": {
                                    "streetLines": RecStreetLines,
                                    "stateOrProvinceCode": this.state.RecipientState,
                                    "city": this.state.RecipientCity,
                                    "postalCode": this.state.RecipientPostalCode,
                                    "countryCode": "US",
                                    "residential": false
                                },
                                "contact": {
                                    "personName": this.state.RecipientName,
                                    "phoneNumber": this.state.RecipientContactNo,
                                    "companyName": this.state.RecipientStreet1
                                },
                                "deliveryInstructions": this.state.DeliveryInstructions
                            },
                            "pickupType": picktype,
                            "serviceType": SerType,
                            "packagingType": "YOUR_PACKAGING",
                            "shippingChargesPayment": {
                                "paymentType": "SENDER",
                                "payor": {
                                    "responsibleParty": {
                                        "accountNumber": {
                                            "value": ""
                                        }
                                    }
                                }
                            },
                            "freightShipmentDetail": {
                                "role": "SHIPPER",
                                "totalHandlingUnits": lineitemscount,
                                "lineItem": freightlineItems,
                                "printedReferences": [{
                                    "printedReferenceType": "SHIPPER_ID_NUMBER",
                                    "value": Workorder
                                }],
                                "alternateBillingParty": {
                                    "accountNumber": {
                                        "value": ""
                                    },
                                    "contact": {
                                        "companyName": "SDI",
                                        "phoneNumber": phonenum
                                    },
                                    "address": {
                                        "streetLines": [
                                            ""
                                        ],
                                        "city": "",
                                        "stateOrProvinceCode": "",
                                        "postalCode": "",
                                        "countryCode": "US"
                                    }

                                }
                            },
                            "labelSpecification": {
                                "imageType": "ZPLII",
                                "labelFormatType": "COMMON2D",
                                "labelStockType": "STOCK_4X6"
                            },
                            "shippingDocumentSpecification": {
                                "shippingDocumentTypes": [
                                    "FEDEX_FREIGHT_STRAIGHT_BILL_OF_LADING"
                                ],
                                "freightBillOfLadingDetail": {
                                    "format": {
                                        "stockType": "PAPER_LETTER",
                                        "docType": "PDF"
                                    }
                                }
                            },
                            "requestedPackageLineItems": reqfreightlineitems
                        },
                        "accountNumber": {
                            "value": ""
                        }
                    }
                }
                let searchObj = {
                    FedexDetails: ShippingPayload,
                    AccessToken: accesstoken,
                    ShipType: shiptype,
                    OrderNo: this.state.OrderValue.value,
                    busunit: CookieService.getLocalStorageValues("Session_BUSUNIT"),
                    userID: CookieService.getLocalStorageValues("Session_UserID"),
                    ShipmentType: this.state.ShippingType.value,
                    ContainerDetails: this.state.attachmentArr
                }

                $(`#${SDIConstants.SDILoader}`).removeClass('hide');
                ShippingAction.SubmitClick(searchObj);
            }
            else {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: 'Oops, Something went wrong'
                });
            }
        }
        else {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: 'Oops, Something went wrong'
            });
        }


    }
    SubmitClickResponse = () => {
        //debugger
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        let Respon = JSON.parse(ShippingStore.SubmitClickData);
        if (Respon == "false") {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "There is an error in Inserting images against the Containers"
            });
            return;
        }
        if (Respon == "" || Respon == undefined || Respon == {}) {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: 'Shipment Failed'
            });

            // alert('Shipment Failed');
            return;
        }
        let BOLUrl = "";
        let Response = JSON.parse(Respon);
        let outpit = Response.output;
        let transdoc = outpit.transactionShipments
        let ShipDoc = transdoc[0].shipmentDocuments;
        let URL;
        let tracknum;
        let LocPackUrls = [];
        /*PC_CPW_313_08, Yuvarani K */
        let ContainerArr = [];
        let orderDetail = this.state.orderArr;
        let ShippingType = this.state.ShippingType.value;
        if (this.state.ShippingType.value == "FedEx") {
            if (ShipDoc != undefined) {
                URL = ShipDoc[0].url;
                tracknum = ShipDoc[0].trackingNumber;
                let pieceobj = {
                    LINE_NBR: 1,
                    URL: ShipDoc[0].encodedLabel,
                    PackTrackNo: tracknum
                }
                LocPackUrls.push(pieceobj);
            }
            else {
                let pieceres = transdoc[0].pieceResponses;
                tracknum = pieceres[0].masterTrackingNumber;
                if (pieceres.length > 0) {
                    pieceres.forEach((val, index) => {
                        let packagedoc = pieceres[index].packageDocuments;
                        let pieceobj = {
                            LINE_NBR: this.state.orderArr[index].ORDER_INT_LINE_NO,
                            URL: packagedoc[0].encodedLabel,
                            PackTrackNo: val.trackingNumber,
                            /*PC_CPW_313_09, Yuvarani K */
                            ORDER_NO: this.state.orderArr[0].ORDER_NO
                        }
                        LocPackUrls.push(pieceobj);
                    })

                }
                /*PC_CPW_313_11 - PC_CPW_313_14, Yuvarani K*/
                if (orderDetail != undefined && orderDetail != null) {
                    if (orderDetail.length > 0) {
                        orderDetail.forEach((val, index) => {
                            let containerObj =
                            {
                                ORDER_NO: val.ORDER_NO,
                                containerId: val.SHIP_CNTR_ID
                            }
                            ContainerArr.push(containerObj);
                        })


                    }

                }
            }
        }
        else {
            //URL = ShipDoc[0].encodedLabel;
            ////tracknum = ShipDoc[0].trackingNumber;
            //tracknum = transdoc[0].masterTrackingNumber;
            //let pieceobj = {
            //    LINE_NBR: 1,
            //    URL: ShipDoc[0].encodedLabel
            //}
            //LocPackUrls.push(pieceobj);
            let pieceres = transdoc[0].pieceResponses;
            tracknum = transdoc[0].masterTrackingNumber;
            let BOLdata = transdoc[0].shipmentDocuments;
            BOLUrl = BOLdata[0].url;
            if (pieceres.length > 0) {
                pieceres.forEach((val, index) => {
                    let packagedoc = pieceres[index].packageDocuments;
                    let pieceobj = {
                        LINE_NBR: this.state.orderArr[index].ORDER_INT_LINE_NO,
                        URL: packagedoc[0].url,
                        PackTrackNo: val.trackingNumber,
                        /* PC_CPW_313_15, Yuvarani K */
                        ORDER_NO: this.state.orderArr[0].ORDER_NO
                    }
                    LocPackUrls.push(pieceobj);
                })

            }
            /* PC_CPW_313_16 - PC_CPW_313_19, Yuvarani K */
            if (orderDetail != undefined && orderDetail != null) {
                if (orderDetail.length > 0) {
                    orderDetail.forEach((val, index) => {
                        let containerObj =
                        {
                            ORDER_NO: val.ORDER_NO,
                            containerId: val.SHIP_CNTR_ID
                        }
                        ContainerArr.push(containerObj);
                    })


                }
            }
        }
        if (tracknum != undefined && tracknum != "") {
            console.log("testtrack", tracknum);
            let UpdateTrackNoBO = {
                OrderNo: this.state.OrderValue.value,
                TrackNum: tracknum,
                EncodedLabel: "",
                ListOfUrls: LocPackUrls,
                Shipment_Type: this.state.ShippingType.value,
                User_Crib: CookieService.getLocalStorageValues("Session_ISA_CRIB_IDENT"),
                URLOfBOL: BOLUrl,
                /* PC_CPW_313_20, Yuvarani K */
                containerArray: ContainerArr
            }
            $(`#${SDIConstants.SDILoader}`).removeClass('hide');
            ShippingAction.UpdatetrackNum(UpdateTrackNoBO);
            /* PC_CPW_313_21, Yuvarani K */
            this.setState({
                TrackNumb: tracknum, ListOfPackUrls: LocPackUrls, containerArray: ContainerArr, pdfUrl: URL, PrintingShipType: ShippingType, MainFedexGrid: [], ShippingType: "", PickUpType: "", OrderValue: "", ServiceValue: "", HDRPackType: "", RecipientDesc: "", RecipientAddress: "", DeliveryInstructions: "", ShowDescAddress: false, RecipientName: "", RecipientContactNo: "", FreightBOLUrl: BOLUrl,
                ConOrderNo: "",
                isFromCon: false,
                isFright: ""
            });
            // $('#SuccessPop').modal('show');
        }
    }




    UpdateTrackNumRespnse = () => {
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        let Respon = JSON.parse(ShippingStore.UpdatetrackNum);
        /*PC_CPW_313_23 - PC_CPW_313_26, Yuvarani K */

        let trackingArray = Respon.TrackingDetails
        let Response = Respon.UpdateResponse
        if (Response[0].SuccessMessage == "Updation Success") {
            this.setState({ ISBOLPrinting: false, UpdateResponse: true, TrackingArray: trackingArray })
            $('#SuccessPop').modal('show');
        }
        else {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: 'Tracking Number Updation Failed'
            });
            // alert('Tracking Number Updation Failed');
        }
    }
    /* PC_CPW_313_33 - PC_CPW_313_35, Yuvarani K */
    CopyTrackingNum = (e, TrackingNumber) => {
        Copy(TrackingNumber);
        MenuAction.CopyMessage();
    }

    /* PC_CPW_313_27 - PC_CPW_313_32, Yuvarani K */
    bindTrackingNo = () => {
        if (this.state.TrackingArray.length > 0) {
            return this.state.TrackingArray.map((val, index) => {
                //debugger
                return (<>
                    <tr>

                        <td class="text-black">{val.CONTAINER_ID}</td>
                        <td class="text-black">{val.TRACKING_NUM} <span onClick={(e) => this.CopyTrackingNum(e, val.TRACKING_NUM)}><img className="px-1" src="Images/CopyImage.png" alt="Copy" title="Copy" style={{ height: '20px' }} /></span> </td>
                    </tr>
                </>
                )
            });
        }
    }

    PrintRespnse = () => {
        debugger
        /*PC_CPW_313_37 - PC_CPW_313_38, Yuvarani K */
        $('#PrintPopUp').modal('hide');
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        let Respon = ShippingStore.PrintLabel;
        if (Respon == "FreightSuccess") {
            this.setState({ ISBOLPrinting: true });
            //To get the default printer value
            this.getDefaultPrinter()
            $('#PrintPopUp').modal('show');
            return;
        }

        else if (Respon == "FreightFailed") {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: 'Freight Printing Failed'
            });
            this.setState({
                ReprintcontainerOptions: [], ReprintOrderValue: "", ReprintTrackingNo: "", isSuccess: true, OrderSelected: false
            })
            return;
        }
        else if (Respon == "BOLPrintFailed") {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: 'BOL Printing Failed'
            });
            this.setState({
                ReprintcontainerOptions: [], ReprintOrderValue: "", ReprintTrackingNo: "", isSuccess: true, OrderSelected: false
            })
            return;
        }
        else if (Respon == "FedExFailed") {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: 'FedEx Printing Failed'
            });
            this.setState({
                ReprintcontainerOptions: [], ReprintOrderValue: "", ReprintTrackingNo: "", isSuccess: true, OrderSelected: false
            })
            return;
        }//PC_WW_1098_01 -Aparna (6/19/2024)
        else if (Respon == "BOLPrintSuccess") {
            /*PC_CPW_313_40 - Yuvarani K */
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: 'BOL Sucessfully Printed'
            });
            this.setState({
                ReprintcontainerOptions: [], ReprintOrderValue: "", ReprintTrackingNo: "", isSuccess: true, OrderSelected: false
            })
            return;

        }
        else if (Respon == "FedExSuccess") {
            /*PC_CPW_313_43 - Yuvarani K */
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: 'Sucessfully Printed'
            });
            this.setState({
                ReprintcontainerOptions: [], ReprintOrderValue: "", ReprintTrackingNo: "", isSuccess: true, OrderSelected: false
            })
            return;

        }
        else {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: 'Technical issue, please try again'
            });
            this.setState({
                ReprintcontainerOptions: [], ReprintOrderValue: "", ReprintTrackingNo: "", isSuccess: true, OrderSelected: false
            })
            return;
        }



    }
    bindReprintOrders = (ReprintOrderArray) => {
        //debugger
        let ReprintOrderArrayvalue = []
        if (ReprintOrderArray != undefined && ReprintOrderArray != null) {
            if (ReprintOrderArray.length > 0) {
                ReprintOrderArray.map((val, index) => {
                    let localArray = {
                        value: val.ORDER_NO,
                        label: val.ORDER_NO,
                    }
                    ReprintOrderArrayvalue.push(localArray)

                });
            }
        }
        let pp = ReprintOrderArrayvalue.filter((ele, ind) => ind === ReprintOrderArrayvalue.findIndex(elem => elem.value === ele.value && elem.label === ele.label))
        this.setState({ ReprintOrderOptions: pp, ReprintOrderArray: ReprintOrderArray });

    };





    BindOrderNumber = (OrderArray) => {
        //debugger
        let OrderArrayvalue = []
        if (OrderArray.length > 0) {
            OrderArray.map((val, index) => {
                let localArray = {
                    value: val.ORDER_NO,
                    label: val.ORDER_NO,
                }
                //CPW-327 Redirect to FedEx panel - Nandhini L
                if (this.state.isFromCon) {
                    if (val.ORDER_NO === this.state.ConOrderNo) {
                        let LTLValue = val.SHIP_TYPE_ID;
                        if (LTLValue !== "" && LTLValue !== null && LTLValue !== undefined) {
                            if (LTLValue.trim() === "FEDEX FRGT") {
                                this.setState({ isFright: "true" })
                            }
                            else {
                                this.setState({ isFright: "false" })
                            }
                        }
                        let localArray1 = {
                            value: val.ORDER_NO,
                            label: val.ORDER_NO,
                        }
                        this.setState({ OrderValue: localArray1 })
                    }
                }
                OrderArrayvalue.push(localArray)
            });
        }
        let pp = OrderArrayvalue.filter((ele, ind) => ind === OrderArrayvalue.findIndex(elem => elem.value === ele.value && elem.label === ele.label))
        this.setState({ OrderOptions: pp, OrderArray: OrderArray });
        //CPW-327 Redirect to FedEx panel - Nandhini L
        if (this.state.isFromCon == true) {
            this.handleOrderChange("", false)
        }
    };
    HandleChange = (e, type) => {
        //debugger
        const costre = SDIConstants.CostRegEx;
        const re = SDIConstants.quantityRegEX;
        let RegExp = /^\d*\.?\d*$/;
        if (type == "ContactNo") {
            //debugger;
            if (e.target.value === '' || re.test(e.target.value)) {
                this.setState({ [e.target.name]: e.target.value });
            }
        }
        else {
            this.setState({ [e.target.name]: e.target.value });
        }
    };
    ReprintBtnClick = (e) => {
        //debugger
        if (this.state.ReprintOrderValue == "") {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: 'Please select an order to reprint'

            });
            return;
        }
        else {
            //To get the default printer value
            this.getDefaultPrinter()

            if (this.state.PrinterOptions.length > 0) {
                this.setState({ ISBOLPrinting: false });
                $('#PrintPopUp').modal('show');
            }
            else {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: 'Zebra printers are not available to print the labels'

                });
                // alert('No Zebra Printer Is Connected To This Device');
            }
        }
    }
    PrintLabel = (e) => {
        //debugger
        if (this.state.PrinterOptions.length > 0) {
            //To get the default printer value
            this.getDefaultPrinter()

            $('#SuccessPop').modal('hide');
            $('#PrintPopUp').modal('show');

        }
        else {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Zebra printers are not available to print the labels"
            });
            // alert('No Zebra Printer Is Connected To This Device');
        }
    }
    PrintBOL = (e) => {
        //debugger
        if ((Object.keys(this.state.BOLPrinterValue).length == 0)) {
            if (this.state.BOLPrinterOptions.length == 0) {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: 'Printers are not available to print BOL'
                });
            }
            else {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: 'Please select a printer name to print'
                });
            }
        }
        else {
            let BOLLabelObj;

            // Check state BolDefaultCheck conditions to update local storage
            if (this.state.BolDefaultCheck) {
                CookieService.updateLocalStorageValues("BOLPrinterValue", this.state.BOLPrinterValue)
            } else {
                CookieService.updateLocalStorageValues("BOLPrinterValue", "")
            }

            if (this.state.IsReprintTab) {
                let RepOrdArr = this.state.ReprintOrderArray.filter((x) => x.ORDER_NO == this.state.SelectedreprintOrder && x.LINE_NBR >= 0 && x.SHIPMENT_TYPE == 'FreightBOL' && x.CONTAINER_ID == this.state.containerValue.value);

                BOLLabelObj = {
                    ZPLUrl: RepOrdArr[0].ZPL_URL,
                    PrinterName: this.state.BOLPrinterValue.value,
                    IsFreight: true,
                    LabelType: "BOLLABEL",
                    Order_No: RepOrdArr[0].ORDER_NO
                }
            }
            else {
                BOLLabelObj = {
                    ZPLUrl: this.state.FreightBOLUrl,
                    PrinterName: this.state.BOLPrinterValue.value,
                    IsFreight: true,
                    LabelType: "BOLLABEL",
                    Order_No: this.state.orderArr[0].ORDER_NO
                }
            }
            $(`#${SDIConstants.SDILoader}`).removeClass('hide');
            ShippingAction.PrintLabel(BOLLabelObj);
        }
    }
    PrintZebraLabel = (e) => {
        //debugger
        if ((Object.keys(this.state.PrinterValue).length == 0)) {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: 'Please select a printer name'
            });
            // alert('Please Select A Printer Name');
        }
        else {

            let EncOrZpl = "";
            let IsFreight = false

            // Check state BolDefaultCheck conditions to update local storage
            if (this.state.DefaultCheck) {
                CookieService.updateLocalStorageValues("PrinterValue", this.state.PrinterValue)
            } else {
                CookieService.updateLocalStorageValues("PrinterValue", "")
            }

            if (this.state.IsReprintTab) {
                let RepOrderArr = this.state.ReprintOrderArray.filter((x) => x.ORDER_NO == this.state.SelectedreprintOrder && x.LINE_NBR != 0);
                let LocPackUrls = [];
                let Shiptype = RepOrderArr[0].SHIPMENT_TYPE;
                if (Shiptype == "FedEx") {
                    IsFreight = false
                }
                else {
                    IsFreight = true
                }
                if (IsFreight == true) {
                    RepOrderArr.forEach((val, index) => {

                        if (val.SHIPMENT_TYPE == 'FedExLTL') {
                            if (val.CONTAINER_ID == this.state.containerValue.value) {
                                let pieceobj = {
                                    LINE_NBR: index + 1,
                                    URL: val.ZPL_URL
                                }

                                LocPackUrls.push(pieceobj);
                            }
                        }

                    });
                }


                else {
                    RepOrderArr.forEach((val, index) => {

                        if (val.SHIPMENT_TYPE == 'FedEx') {
                            if (val.CONTAINER_ID == this.state.containerValue.value) {
                                let pieceobj = {
                                    LINE_NBR: index + 1,
                                    URL: val.ZPL_URL
                                }

                                LocPackUrls.push(pieceobj);


                            }
                        }
                    });
                }


                let PrintLabelObj = {
                    ZPLUrl: "",
                    PrinterName: this.state.PrinterValue.value,
                    IsFreight: IsFreight,
                    ListOfUrls: LocPackUrls,
                    LabelType: "ZebraLabel",
                    Order_No: RepOrderArr[0].ORDER_NO
                }
                $(`#${SDIConstants.SDILoader}`).removeClass('hide');
                ShippingAction.PrintLabel(PrintLabelObj);
            }
            else {
                if (this.state.PrintingShipType == "FedEx") {
                    IsFreight = false
                }
                else {
                    IsFreight = true
                }
                //EncOrZpl = this.state.ReprintEncodedLabel;
                let PrintLabelObj = {
                    ZPLUrl: "",
                    PrinterName: this.state.PrinterValue.value,
                    IsFreight: IsFreight,
                    ListOfUrls: this.state.ListOfPackUrls,
                    LabelType: "ZebraLabel",
                    Order_No: this.state.orderArr[0].ORDER_NO
                }
                $(`#${SDIConstants.SDILoader}`).removeClass('hide');
                ShippingAction.PrintLabel(PrintLabelObj);
            }

        }
    }
    OkClick = () => {
        if (this.state.IsReprintTab) {
            $('#PrintPopUp').modal('hide');
        }
        else {
            if (this.props.location.state && this.props.location.state.OrderNo != undefined && this.props.location.state.OrderNo != null && this.props.location.state.OrderNo != "") {
                this.props.history.push({
                    state: ""
                });
            }
            window.location.reload();
            $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        }

    }
    CancelPrint = () => {
        if (this.state.IsReprintTab) {
            $('#PrintPopUp').modal('hide');
        }
        else {
            $('#SuccessPop').modal('show');
            $('#PrintPopUp').modal('hide');
        }

    }
    CancelBOL = () => {
        if (this.state.IsReprintTab) {
            $('#PrintPopUp').modal('hide');
        }
        else {
            window.location.reload();
            $('#SuccessPop').modal('hide');
            $('#PrintPopUp').modal('hide');
        }

    }
    BindShippingType = () => {
        //debugger
        let ShippingArrayValue = [];
        let localobj = {
            value: "FedEx",
            label: "Fedex Shipping"
        }
        let localobj1 = {
            value: "FedExLTL",
            label: "Freight Shipping"
        }
        ShippingArrayValue.push(localobj);
        ShippingArrayValue.push(localobj1);
        this.setState({ ShippingArray: ShippingArrayValue });
        //CPW-327 Redirect to FedEx panel - Nandhini L
        if (this.state.isFromCon == true) {
            if (this.state.isFright == "false") {
                this.setState({ ShippingType: localobj })
            }
            else {
                this.setState({ ShippingType: localobj1 })
            }
            this.handleShippingChange("")
        }

    };
    BindPickUpType = () => {
        //debugger
        let PickUpArrayValue = [
            { "value": "DROPOFF_AT_FEDEX_LOCATION", "label": "DROPOFF AT FEDEX LOCATION" },
            { "value": "USE_SCHEDULED_PICKUP", "label": "USE SCHEDULED PICKUP" }];
        //CPW-327 Redirect to FedEx panel - Nandhini L
        if (this.state.isFromCon == true) {
            this.setState({ PickUpType: PickUpArrayValue[1] })
        }
        this.setState({ PickUpArray: PickUpArrayValue });

    };
    BindPackageType = (PackageArray) => {
        //debugger
        let PackageArrayvalue = []
        let localArray1 = []
        if (PackageArray.length > 0) {
            PackageArray.map((val, index) => {
                let localArray = {
                    value: val.PACKAGEID,
                    label: val.DESCR,
                }
                //CPW-327 Redirect to FedEx panel - Nandhini L
                if (this.state.isFromCon == true) {
                    if (this.state.isFright == "false") {
                        localArray1 = {
                            value: "YOUR_PACKAGING",
                            label: "Customer Packaging"
                        }
                    }
                    this.setState({ HDRPackType: localArray1 })
                }

                PackageArrayvalue.push(localArray);
            });
        }
        this.setState({ SubPackageOptions: PackageArrayvalue, HDRPackArray: PackageArrayvalue });

    };
    BindPrinterTypes = (PrinterNames, CribName) => {
        //debugger
        //CPW-238 - FedEx - WM07157733 “tracking number updating error” When Creating FedEx Label - Deepthi
        let cribID = CookieService.getLocalStorageValues("Session_ISA_CRIB_IDENT");
        let PrinterNamevalue = [];
        let locBOLPrinterNames = [];
        let PrinterValues = PrinterNames.split("|")
        if (PrinterValues.length > 0) {
            PrinterValues.map((val, index) => {
                if (val.toLowerCase().includes(cribID.toLowerCase().trim()) && !val.toLowerCase().includes("bol")) {
                    let localArray = {
                        value: val,
                        label: val.replace(cribID, ""),
                    }
                    PrinterNamevalue.push(localArray);
                };
                if (val.toLowerCase().includes(cribID.toLowerCase().trim()) && val.toLowerCase().includes("bol")) {
                    let locBOLPrinters = {
                        value: val,
                        label: val.replace(cribID, ""),
                    }
                    locBOLPrinterNames.push(locBOLPrinters);
                };
            });
        }
        this.setState({ PrinterOptions: PrinterNamevalue, BOLPrinterOptions: locBOLPrinterNames });
    };
    BindServiceType = (ServiceArray) => {
        //debugger
        let ServiceArrayvalue = []
        let localArray1 = []
        if (ServiceArray.length > 0) {
            ServiceArray.map((val, index) => {
                let localArray = {
                    value: val.ISA_CONTAINER_ID,
                    label: val.DESCR,
                }

                //CPW-327 Redirect to FedEx panel - Nandhini L
                if (this.state.isFromCon == true) {
                    if (this.state.isFright == "false" && val.ISA_CONTAINER_ID == "PRIORITY_OVERNIGHT") {
                        localArray1 = {
                            value: val.ISA_CONTAINER_ID,
                            label: val.DESCR,
                        }

                        this.setState({ ServiceValue: localArray1 })
                    }
                }

                ServiceArrayvalue.push(localArray);

            });
        }

        this.setState({ ServiceTypeArray: ServiceArrayvalue });
    }

    /* PC_CPW_313_45 - PC_CPW_313_59, Yuvarani K */
    bindContainers = (containerOption, selectedOrder) => {
        //debugger;
        let containerValue = [];
        if (containerOption.length > 0) {
            if (containerOption[0].containerId == null) {
                let trackingNumber = this.state.ReprintOrderArray.find(item => item.ORDER_NO == selectedOrder);
                if (trackingNumber != undefined && trackingNumber != null) {
                    this.setState({
                        ReprintTrackingNo: trackingNumber.TRACKING_NUM, containerValue: ""
                    });
                }

            } else {
                containerOption.map((val, index) => {
                    let localArray = {
                        value: val.containerId,
                        label: val.containerId,
                    }
                    containerValue.push(localArray)
                });

                let pp = containerValue.filter((ele, ind) => ind === containerValue.findIndex(elem => elem.value === ele.value && elem.label === ele.label))
                if (pp != undefined && pp != null) {
                    this.setState({
                        ReprintcontainerOptions: pp
                    });


                }
                else {
                    this.setState({ ReprintcontainerOptions: [], ReprintTrackingNo: "" });
                }


            }

        }
        /*
         else {
             containerOption.map((val, index) => {
                 let localArray = {
                     value: "",
                     label: "",
                 }
                 containerValue.push(localArray)
             });
         }*/



    };





    handleOrderChange = (e, isChange) => {

        //debugger
        /*PC_CPW_313_60, Yuvarani K */
        this.setState({
            UpdateResponse: false, ShowDescAddress: true, OrderSelected: true
        });
        let temporderdata = ""
        if (e.value != undefined) {
            temporderdata = ""
            this.setState({ isFright: "", isFromCon: false, ConOrderNo: "" })
        }
        else {
            temporderdata = this.state.ConOrderNo
        }

        let maxgrid = this.state.MainFedexGrid;
        let OrderArray = this.state.OrderArray;
        //CPW-327 Redirect to FedEx panel - Nandhini L
        let OrderIndex = [];
        let filteredOrders = [];
        if (this.state.isFromCon == false || isChange == true) {
            OrderIndex = OrderArray.findIndex(elem => elem.ORDER_NO === e.value);
        }
        else {
            OrderIndex = OrderArray.findIndex(elem => elem.ORDER_NO === temporderdata);
        }
        // Step 1: Filter orders based on ORDER_NO
        if (this.state.isFromCon == false || isChange == true) {
            filteredOrders = OrderArray.filter(order => order.ORDER_NO === e.value);
        }
        else {
            filteredOrders = OrderArray.filter(order => order.ORDER_NO === temporderdata);
        }
        // Step 2: Deduplicate based on SHIP_CNTR_ID
        let uniqueOrders = [];
        let seenShipCntrIds = new Set();

        filteredOrders.forEach(order => {
            if (!seenShipCntrIds.has(order.SHIP_CNTR_ID)) {
                uniqueOrders.push(order);
                seenShipCntrIds.add(order.SHIP_CNTR_ID);
            }
        });
        let OrderArr = OrderArray[OrderIndex];
        let hascontinfo = false;
        let recname = "";
        let recphonenum = "";
        if (OrderArr != undefined) {
            if (OrderArr.ISA_EMPLOYEE_NAME == " " || OrderArr.ISA_EMPLOYEE_NAME == null) {
                hascontinfo = false;
                recname = "";
                recphonenum = "";
            }
            else {
                hascontinfo = true;
                recname = OrderArr.ISA_EMPLOYEE_NAME;
                recphonenum = OrderArr.PHONE_NUM;
                recphonenum = recphonenum.replaceAll("/", "");
                recphonenum = recphonenum.replaceAll("-", "");
            }
        }
        else {
            //swal({
            //    allowOutsideClick: false,
            //    closeOnClickOutside: false,
            //    text: "Techincal Issue Contact SDI Customer Care"
            //});
            this.setState({
                ConOrderNo: "",
                isFromCon: false,
                isFright: "",
                ShowDescAddress: ""
            })
            this.PageLoad()
            return;
        }
        this.setState({
            OrderValue: temporderdata == "" ? e : this.state.OrderValue,
            OrderName: temporderdata == "" ? e.value : this.state.OrderValue,
            ShowDescAddress: true,
            hasRecipientInfo: hascontinfo,
            RecipientName: recname,
            ShipperName: OrderArr.SHIPPERNAME,
            RecipientContactNo: recphonenum,
            RecipientStreet1: OrderArr.ADDRESS1,
            RecipientStreet2: OrderArr.ADDRESS2,
            RecipientStreet3: OrderArr.ADDRESS3,
            RecipientCity: OrderArr.CITY,
            RecipientState: OrderArr.STATE,
            RecipientPostalCode: OrderArr.POSTAL,
            RecipientDesc: OrderArr.DESCR,
            FilteredOrders: filteredOrders,
            RecipientAddress: `${OrderArr.ADDRESS2} ${OrderArr.CITY} ${OrderArr.STATE} ${OrderArr.POSTAL}`,
            orderArr: uniqueOrders
        }, () => {
            this.AddRowClick();
        });
    }
    handlePackageChange = (e, index) => {
        debugger
        let { MainFedexGrid } = this.state;
        this.state.MainFedexGrid[index].PackageValue = e
        this.setState(
            { MainFedexGrid: MainFedexGrid });
        console.log('packageChange', this.state.PackageValue)
    }
    handleWeightChange = (event, index) => {
        //debugger
        //if (e.target.value == "-" ) {
        //    e.preventDefault();
        //}
        // const re = SDIConstants.quantityRegEX;
        let { MainFedexGrid } = this.state;
        const onlyNumbers = SDIConstants.quantityRegEX;
        if (event.target.value === '' || onlyNumbers.test(event.target.value)) {
            if (event.target.value.length <= 10) {
                this.state.MainFedexGrid[index].Weight = event.target.value;
                this.setState({ MainFedexGrid: MainFedexGrid });
            }
        }


        //if (e.target.value === '' || re.test(e.target.value)) {
        //    if (e.target.value != "0") {
        //        this.state.MainFedexGrid[index].Weight = e.target.value;
        //        this.setState(
        //            { MainFedexGrid: MainFedexGrid });
        //    }
        //};

    }
    handleServiceChange = (e) => {
        //debugger
        this.setState(
            { ServiceValue: e });
    }

    /* PC_CPW_313_61 - PC_CPW_313_67, Yuvarani K */
    handleContainers = (e) => {

        let selectedContainer = e.value

        let trackingNumber = this.state.ReprintOrderArray.find(item => item.CONTAINER_ID == selectedContainer);
        if (trackingNumber != undefined && trackingNumber != null) {
            this.setState({
                ReprintTrackingNo: trackingNumber.TRACKING_NUM, containerValue: e
            });
        }
        else {
            this.setState({
                ReprintTrackingNo: "", containerValue: ""
            });
        }
    }
    handleReprintOrders = (e) => {
        //debugger


        let RepOrderArray = this.state.ReprintOrderArray;
        //let RepOrderIndex = RepOrderArray.findIndex(elem => elem.ORDER_NO === e.value);

        let RepOrderArr = RepOrderArray.filter((x) => x.ORDER_NO == e.value)
        /* PC_CPW_313_68 - PC_CPW_313_76,  Yuvarani K */
        let containerIDs = [];

        if (RepOrderArr) {
            RepOrderArr.forEach((val, index) => {
                let obj = {
                    containerId: val.CONTAINER_ID
                }
                containerIDs.push(obj);

                containerOption = containerIDs;





            });
            //CPW-313 - Nandhini L
            this.bindContainers(containerOption, e.value);

            //let RepOrderArr = RepOrderArray[RepOrderIndex];
            this.setState(
                {
                    ReprintOrderValue: e, ReprintEncodedLabel: "", ReprintTrackingNum: RepOrderArr[0].TRACKING_NUM, SelectedreprintOrder: e.value, containerValue: ""
                });
        }
        else {
            containerOption = []
            this.setState(
                {
                    ReprintOrderValue: e, ReprintEncodedLabel: "", ReprintTrackingNum: RepOrderArr[0].TRACKING_NUM, SelectedreprintOrder: e.value, containerOption: [], containerValue: ""
                });

        }

    }
    handleShippingChange = (e) => {
        //debugger
        /*PC_CPW_313_77, Yuvarani K */
        this.setState({ isSuccess: false })
        let locMainFedexGrid = [];
        //CPW-327 Redirect to FedEx panel
        let localArray1 = []
        let locobj;
        localArray1 = {
            value: "YOUR_PACKAGING",
            label: "Customer Packaging"
        }
        if (e.value != undefined) {
            this.state.isFright = ""
            this.state.isFromCon = false
        }
        if (e.value == "FedEx" || this.state.isFright == "false") {
            this.BindServiceType(this.state.ServiceArray);
            this.BindPackageType(this.state.PackageArray);
            let PackageArrayvalue = []
            if (this.state.PackageArray.length > 0) {
                this.state.PackageArray.map((val, index) => {
                    let localArray = {
                        value: val.PACKAGEID,
                        label: val.DESCR,
                    }
                    PackageArrayvalue.push(localArray);
                });
            }
            this.state.orderArr.map((value, item) => {
                if (this.state.isFromCon == true) {
                    locobj = {
                        packagetypearray: PackageArrayvalue,
                        Weight: "",
                        Units: "LB",
                        IsDelete: false,
                        PackageValue: localArray1,
                    }
                }
                else {
                    locobj = {
                        packagetypearray: PackageArrayvalue,
                        Weight: "",
                        Units: "LB",
                        IsDelete: false,
                        PackageValue: ""

                    }
                }

                locMainFedexGrid.push(locobj);
            })
        }
        //CPW-327 Redirect to FedEx panel
        else if (e.value == "FedExLTL" || this.state.isFright == "true") {
            let SubPack = [{ "value": "BAG", "label": "BAG" }, { "value": "BARREL", "label": "BARREL" },
            { "value": "BUCKET", "label": "BUCKET" },
            { "value": "ENVELOPE", "label": "ENVELOPE" }, { "value": "PAIL", "label": "PAIL" },
            { "value": "PALLET", "label": "PALLET" }, { "value": "PARCEL", "label": "PARCEL" }, { "value": "REEL", "label": "REEL" }, { "value": "ROLL", "label": "ROLL" },
            { "value": "SKID", "label": "SKID" }, { "value": "TANK", "label": "TANK" }, { "value": "TUBE", "label": "TUBE" }];
            this.state.orderArr.map((value, item) => {
                if (this.state.isFromCon == true) {
                    locobj = {
                        packagetypearray: SubPack,
                        Weight: "",
                        Units: "LB",
                        IsDelete: false,
                        PackageValue: SubPack[5]
                    }
                }
                else {
                    locobj = {
                        packagetypearray: SubPack,
                        Weight: "",
                        Units: "LB",
                        IsDelete: false,
                        PackageValue: ""
                    }
                }
                locMainFedexGrid.push(locobj);
            })
            let HdrFreightService = [{ "value": "FEDEX_FREIGHT_PRIORITY", "label": "FedEx Freight PRIORITY" }, { "value": "FEDEX_FREIGHT_ECONOMY", "label": "FedEx Freight ECONOMY" }];
            /* Regression bug - 5220, Yuvarani K */

            let HdrFreightPack = [{ "value": "FEDEX_EXPRESS_SERVICES", "label": "FedEx Express Services" }, { "value": "FEDEX_SMARTPOST_SERVICES", "label": "FedEx SmartPost Services" }];
            //CPW-327 Redirect to FedEx panel
            if (this.state.isFromCon == true && e.value == undefined) {
                this.setState({ HDRPackType: HdrFreightPack[0], ServiceValue: HdrFreightService[0] })
            }

            this.setState({ HDRPackArray: HdrFreightPack, ServiceTypeArray: HdrFreightService });
        }

        if (e.value != undefined || this.state.isFromCon == false) {
            this.setState({ ServiceValue: "", HDRPackType: "", ShippingType: e })
        }
        this.setState({ MainFedexGrid: locMainFedexGrid })


    }
    handleHDRPackChange = (e) => {
        //debugger
        this.setState(
            { HDRPackType: e });
    }
    handlePrinterChange = (e) => {
        //debugger
        this.setState(
            { PrinterValue: e });
    }
    handleBOLPrinterChange = (e) => {
        //debugger
        this.setState(
            { BOLPrinterValue: e });
    }
    handlePickUpChange = (e) => {
        //debugger
        this.setState(
            { PickUpType: e });
    }

    BindGridData = () => {
        //debugger
        console.log("MainFedexGrid", this.state.MainFedexGrid);
        if (this.state.orderArr.length > 0) {
            return this.state.orderArr.map((value, index) => {
                if (this.state.MainFedexGrid[index] != undefined && this.state.MainFedexGrid[index] != null) {
                    return (<React.Fragment key={index}>
                        <tr>
                            <td> <label> {this.state.orderArr[index].SHIP_CNTR_ID} </label></td>

                            <td >
                                <Select class="form-control"
                                    id="ContId"
                                    name="ContId"
                                    options={this.state.MainFedexGrid[index].packagetypearray}
                                    value={this.state.MainFedexGrid[index].PackageValue}
                                    onChange={(e) => this.handlePackageChange(e, index)}
                                />
                            </td>

                            <td >
                                <input type="text" min="0" className="form-control" maxLength="10" value={this.state.MainFedexGrid[index].Weight} onChange={(e) => this.handleWeightChange(e, index)} placeholder="Enter Value" name="NewLocAis" />
                            </td>
                            <td > LB </td>
                            <td class="text-center">
                                <span className="browse-btn" onClick={() => this.displayPopUp(index)}>
                                    <button type="button" class="font-medium font-14 btn btn-primary custom-btn-primary primary-btn"><img src="images/upload-icon.svg" alt="upload" class="mr-1" /> Upload</button>
                                </span>
                                <span class="d-flex justify-content-center align-items-top" >
                                    <img class="mr-1" src="images/info-icon-dark.svg" alt="info-icon" hidden={this.state.orderArr[index].PACKING_CD != undefined ? (this.state.orderArr[index].PACKING_CD == null || this.state.orderArr[index].PACKING_CD.trim() == "" ? true : false) : true} /><label class="font-12 font-regular mb-0" hidden={this.state.orderArr[index].PACKING_CD != undefined ? (this.state.orderArr[index].PACKING_CD == null || this.state.orderArr[index].PACKING_CD.trim() == "" ? true : false) : true}>Image required for fragile items</label>
                                </span>

                                <span className="justify-content-center err-msg text-danger" id={`AttachError${index}`}></span>

                            </td>
                        </tr>
                    </React.Fragment>

                    );
                }
                else {
                    return null;
                }
            })

        }
    }

    //On change of the default checkbox in printer popup
    onChangeDefaultPrinter = (event) => {
        if (this.state.ISBOLPrinting) {
            this.setState({ BolDefaultCheck: event.target.checked });
        } else {
            this.setState({ DefaultCheck: event.target.checked });
        }
    }

    //To get the default printer value
    getDefaultPrinter = () => {
        // Retrieve BOLPrinterValue and PrinterValue from local storage
        const BOLPrinterValue = CookieService.getLocalStorageValues("BOLPrinterValue") || "";
        const PrinterValue = CookieService.getLocalStorageValues("PrinterValue") || "";

        // Update the state accordingly
        this.setState({
            BOLPrinterValue: BOLPrinterValue,
            BolDefaultCheck: BOLPrinterValue == "" ? false : true,
            PrinterValue: PrinterValue,
            DefaultCheck: PrinterValue == "" ? false : true
        });
    }

    render() {
        return (
            <div className="container-fluid content-section content-margin">

                <div className="row">
                    <div className="col-md-12 page-heading mb-3">
                        <h5 className="page-title">Shipping</h5>
                        <div className="fav-item-maintenance-icon mt-1">
                            <input type="checkbox" id="checkbox-OrdStatus" className="checknow" name="isFavorited" checked={this.state.isFavorited} onChange={this.handleFavorite} />
                            <label htmlFor="checkbox-OrdStatus">
                                <svg className="heart-svg" viewBox="467 392 58 57" xmlns="http://www.w3.org/2000/svg">
                                    <g className="Group" fill="none" fillRule="evenodd" transform="translate(467 392)">
                                        <path d="M29.144 20.773c-.063-.13-4.227-8.67-11.44-2.59C7.63 28.795 28.94 43.256 29.143 43.394c.204-.138 21.513-14.6 11.44-25.213-7.214-6.08-11.377 2.46-11.44 2.59z" className="heart" fill="#fff" />
                                        <circle className="main-circ" fill="#E2264D" opacity={0} cx="29.5" cy="29.5" r="1.5" />
                                        <g className="grp7" opacity={0} transform="translate(7 6)">
                                            <circle className="oval1" fill="#9CD8C3" cx={2} cy={6} r={2} />
                                            <circle className="oval2" fill="#8CE8C3" cx={5} cy={2} r={2} />
                                        </g>
                                        <g className="grp6" opacity={0} transform="translate(0 28)">
                                            <circle className="oval1" fill="#CC8EF5" cx={2} cy={7} r={2} />
                                            <circle className="oval2" fill="#91D2FA" cx={3} cy={2} r={2} />
                                        </g>
                                        <g className="grp3" opacity={0} transform="translate(52 28)">
                                            <circle className="oval2" fill="#9CD8C3" cx={2} cy={7} r={2} />
                                            <circle className="oval1" fill="#8CE8C3" cx={4} cy={2} r={2} />
                                        </g>
                                        <g className="grp2" opacity={0} transform="translate(44 6)">
                                            <circle className="oval2" fill="#CC8EF5" cx={5} cy={6} r={2} />
                                            <circle className="oval1" fill="#CC8EF5" cx={2} cy={2} r={2} />
                                        </g>
                                        <g className="grp5" opacity={0} transform="translate(14 50)">
                                            <circle className="oval1" fill="#91D2FA" cx={6} cy={5} r={2} />
                                            <circle className="oval2" fill="#91D2FA" cx={2} cy={2} r={2} />
                                        </g>
                                        <g className="grp4" opacity={0} transform="translate(35 50)">
                                            <circle className="oval1" fill="#F48EA7" cx={6} cy={5} r={2} />
                                            <circle className="oval2" fill="#F48EA7" cx={2} cy={2} r={2} />
                                        </g>
                                        <g className="grp1" opacity={0} transform="translate(24)">
                                            <circle className="oval1" fill="#9FC7FA" cx="2.5" cy={3} r={2} />
                                            <circle className="oval2" fill="#9FC7FA" cx="7.5" cy={2} r={2} />
                                        </g>
                                    </g>
                                </svg>
                            </label>
                        </div>
                    </div>
                    <div className="col-md-12">
                        <ul className="nav nav-tabs catalog-tabs-mobile catalog-tabs mb-3" id="myTab" role="tablist">
                            <li className="nav-item">
                                <a className="nav-link active" id="ShippingTab" data-toggle="tab" href="#Pending" role="tab" aria-controls="Pending" aria-selected="true" onClick={(e) => this.PageLoad("1")}><Trans>Shipping Label</Trans></a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link" id="ReprintTab" data-toggle="tab" href="#Counted" role="tab" aria-controls="Counted" aria-selected="false" onClick={(e) => this.PageLoad("2")}><Trans>Reprint Labels</Trans></a>
                            </li>
                        </ul>
                        {this.state.IsReprintTab == false ?
                            <div className="col-md-12 mb-3">
                                {this.state.OrderOptions.length > 0 ? <div className="row">
                                    <div className="col-md-4 col-lg-3 mb-3">
                                        <label className="catalog-label w-100  mandatory-after">Shipping Type</label>
                                        <span style={{ "fontSize": "14px" }}><Select
                                            id="ShippingType"
                                            name="ShippingType"
                                            options={this.state.ShippingArray}
                                            value={this.state.ShippingType}
                                            onChange={(e) => this.handleShippingChange(e)}
                                        /></span>
                                    </div>
                                    {(this.state.ShippingType != "" && this.state.isSuccess == false) ? <div className="col-md-4 col-lg-3 mb-3">
                                        <label className="catalog-label w-100  mandatory-after">PickUp Type</label>
                                        <span style={{ "fontSize": "14px" }}><Select
                                            id="Pickup"
                                            name="Pickup"
                                            options={this.state.PickUpArray}
                                            value={this.state.PickUpType}
                                            onChange={(e) => this.handlePickUpChange(e)}
                                        /></span>
                                    </div> : null}
                                    {(this.state.ShippingType != "" && this.state.isSuccess == false) ? <div className="col-md-4 col-lg-3 mb-3">
                                        <label className="catalog-label w-100  mandatory-after">Order No</label>
                                        <span style={{ "fontSize": "14px" }}><Select
                                            id="ordernumber"
                                            name="ONDD"
                                            options={this.state.OrderOptions}
                                            value={this.state.OrderValue}
                                            onChange={(e) => this.handleOrderChange(e, true)}
                                        /></span>
                                    </div> : null}
                                    {/*<button className="btn btn-primary custom-btn-primary primary-btn float-left ml-3 px-4" onClick={e => this.GetWeight(e)}>Weight</button>*/}

                                    {(this.state.ShowDescAddress && this.state.isSuccess == false) ? <div className="col-md-4 col-lg-3 mb-3">
                                        <label className="catalog-label  mandatory-after" htmlFor="itemId">Description</label>
                                        <input type="text" name="RecipientDesc" disabled='true' value={this.state.RecipientDesc} className="form-control" id="RecipientDesc" />
                                    </div> : null}
                                    {(this.state.ShowDescAddress && this.state.isSuccess == false) ? <div className="col-md-4 col-lg-3 mb-3">
                                        <label className="catalog-label  mandatory-after" htmlFor="cost">Address</label>
                                        <input type="text" name="RecipientAddress" disabled='true' value={this.state.RecipientAddress} className="form-control" id="RecipientAddress1" />
                                    </div> : null}
                                    {this.state.ShippingType.value == "FedExLTL" ? <div className="col-md-4 col-lg-3 mb-3">
                                        <label className="catalog-label  mandatory-after" htmlFor="cost">Delivery Instructions</label>
                                        <input type="text" name="DeliveryInstructions" value={this.state.DeliveryInstructions} maxLength="128" onChange={e => this.HandleChange(e, "DelInst")} className="form-control" id="DeliveryInstructions" />
                                    </div> : null}
                                    {(this.state.ServiceTypeArray.length > 0 && this.state.isSuccess == false) ? <div className="col-md-4 col-lg-3 mb-3">
                                        <label className="catalog-label w-100  mandatory-after">Service Type</label>
                                        <span style={{ "fontSize": "14px" }}><Select
                                            id="ServiceId"
                                            name="ServiceId"
                                            options={this.state.ServiceTypeArray}
                                            value={this.state.ServiceValue}
                                            onChange={(e) => this.handleServiceChange(e)}
                                        /></span>
                                    </div> : null}
                                    {(this.state.HDRPackArray.length > 0 && this.state.isSuccess == false) ? <div className="col-md-4 col-lg-3 mb-3">
                                        <label className="catalog-label w-100  mandatory-after">Package Type</label>
                                        <span style={{ "fontSize": "14px" }}><Select
                                            id="ServiceId"
                                            name="ServiceId"
                                            options={this.state.HDRPackArray}
                                            value={this.state.HDRPackType}
                                            onChange={(e) => this.handleHDRPackChange(e)}
                                        /></span>
                                    </div> : null}


                                    {(this.state.orderArr.length > 0 && this.state.OrderSelected == true) ?
                                        < div class="col-md-12 my-3">
                                            <h6 className="fav-item-title mb-3">Recipient Details</h6>
                                            <div className="row">
                                                <div className="col-md-4 col-lg-3 mb-3">
                                                    <label className="catalog-label w-100 mandatory-after">Name</label>
                                                    <input type="text" id="RecipientName" name="RecipientName" className="form-control" value={this.state.RecipientName} onChange={e => this.HandleChange(e, "RecName")} />
                                                </div>
                                                <div className="col-md-4 col-lg-3 mb-3">
                                                    <label className="catalog-label w-100 mandatory-after">Contact No</label>
                                                    <input type="text" id="RecipientContactNo" name="RecipientContactNo" className="form-control" value={this.state.RecipientContactNo} onChange={e => this.HandleChange(e, "ContactNo")} />
                                                </div>
                                                {this.state.UpdateResponse == false ?
                                                    <div className="col-md-12">
                                                        <div className="table-customstyle-whitespace mt-3">
                                                            <table class="table ZEUS_Grid FOM-grid" id="table">{/*mobileflex-grid = Removed*/}
                                                                <thead>
                                                                    <tr>
                                                                        <th>Container ID</th>
                                                                        <th>Sub Packaging Type</th>
                                                                        <th>Weight</th>
                                                                        <th>Units</th>
                                                                        <th className="text-center">Attachments</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {/*<tr>

                                                                <td >
                                                                    <Select class="form-control"
                                                                        id="ContId"
                                                                        name="ContId"
                                                                        options={this.state.PackageOptions}
                                                                        value={this.state.PackageValue}
                                                                        onChange={(e) => this.handlePackageChange(e)}
                                                                    />
                                                                </td>
                                                    
                                                                <td > 
                                                                    <input type="text" className="form-control" maxLength="4" placeholder="Enter Value" name="NewLocAis" />
                                                                </td>
                                                                <td > LB </td>
                                                                <td >
                                                                    <td className="text-center px-0"><span onClick={(e) => this.onNewCancelClick(e)}><img src="Images/delete-confirm-icon.png" alt="Delete" title="Delete" style={{ height: '25px' }} /></span></td>
                                                                </td>
                                                            </tr>*/}
                                                                    {this.BindGridData()}
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div> : null}


                                                {this.state.UpdateResponse == false ?
                                                    <div className="col-md-12 col-sm-auto col-auto my-3 text-right">
                                                        <button className="btn btn-primary custom-btn-primary primary-btn" onClick={e => this.GetAccessToken(e)}>Submit</button>

                                                        {/*<button className="btn btn-primary custom-btn-primary primary-btn float-left ml-3 px-4" onClick={e => this.GetWeight(e)}>Weight</button>*/}
                                                    </div> : null}
                                                {/*{this.state.h
                                                 * 
                                                 * RecipientInfo ? <div className="col-auto mb-3">
                                                        <label className="catalog-label w-100">Name</label>
                                                        <input type="text" id="RecipientName" name="RecipientName" className="form-control col-md-10 float-left" value={this.state.RecipientName}  />
                                                    </div> : <div className="col-auto mb-3">
                                                            <label className="catalog-label w-100">Name</label>
                                                            <input type="text" id="RecipientName" name="RecipientName" className="form-control col-md-10 float-left" value={this.state.RecipientName} onChange={e => this.HandleChange(e, "RecName")}  />
                                                        </div>}
                                                       {this.state.hasRecipientInfo ? <div className="col-auto mb-3">
                                                        <label className="catalog-label w-100">Contact No</label>
                                                        <input type="text" id="RecipientContactNo" name="RecipientContactNo" className="form-control col-md-10 float-left" value={this.state.RecipientContactNo}  />
                                                    </div> : <div className="col-auto mb-3">
                                                            <label className="catalog-label w-100">Contact No</label>
                                                            <input type="text" id="RecipientContactNo" name="RecipientContactNo" className="form-control col-md-10 float-left" value={this.state.RecipientContactNo} onChange={e => this.HandleChange(e, "ContactNo")}  />
                                                        </div>}*/}
                                                {/* //<div className="col-auto mb-3">
                                                    //    <label className="catalog-label w-100">Comp Name</label>
                                                    //    <input type="text" id="ShipperCompname" name="ShipperCompname" className="form-control col-md-10 float-left" value={this.state.ShipperCompname} onChange={e => this.HandleChange(e, "ShipperCompname")} />
                                                    //</div>
                                                    //<div className="col-auto mb-3">
                                                    //    <label className="catalog-label w-100">Street</label>
                                                    //    <input type="text" id="ShipperStreet" name="ShipperStreet" className="form-control col-md-10 float-left" value={this.state.ShipperStreet} onChange={e => this.HandleChange(e, "ShipperStreet")} />
                                                    //</div>
                                                    //<div className="col-auto mb-3">
                                                    //    <label className="catalog-label w-100">City</label>
                                                    //    <input type="text" id="ShipperCity" name="ShipperCity" className="form-control col-md-10 float-left" value={this.state.ShipperCity} onChange={e => this.HandleChange(e, "ShipperCity")} />
                                                    //</div>
                                                    //<div className="col-auto mb-3">
                                                    //    <label className="catalog-label w-100">Postal Code</label>
                                                    //    <input type="text" id="ShipperPostalCode" name="ShipperPostalCode" className="form-control col-md-10 float-left" value={this.state.ShipperPostalCode} onChange={e => this.HandleChange(e, "ShipperPostalCode")} />
                                                    //</div>*/}
                                            </div>



                                        </div> : null}
                                    {/*Item Info ends here*/}

                                </div> : <section className="site-undercontruction container text-center center-panel pt-4">
                                        <div className="img-section">
                                            <img src="images/nosearch.jpg" alt="imagefile" />
                                        </div>
                                        <p className="search-result-content pt-4"><Trans>No Records found</Trans>
                                        </p>
                                    </section>}
                            </div> :
                            <div className="row">
                                {this.state.ReprintOrderOptions.length > 0 ? <div className="col-md-12 pr-0 float-left mb-4">
                                    <div className="row">
                                        <div className="col-md-3 mb-3" style={{ "marginTop": "20px" }}>
                                            <label className="catalog-label w-100">Order Number</label>
                                            <span style={{ "fontSize": "14px" }}><Select
                                                id="ReprintOrderNum"
                                                name="ReprintOrderNum"
                                                options={this.state.ReprintOrderOptions}
                                                value={this.state.ReprintOrderValue}
                                                onChange={(e) => this.handleReprintOrders(e)}
                                            /></span>
                                        </div>

                                        {this.state.ReprintcontainerOptions.length > 0 ?

                                            <div className="col-md-3 mb-3" style={{ "marginTop": "20px" }}>
                                                <label className="catalog-label w-100">Container Id</label>
                                                <span style={{ "fontSize": "14px" }}><Select
                                                    id="ContainerID"
                                                    name="ContainerID"
                                                    options={this.state.ReprintcontainerOptions}
                                                    value={this.state.containerValue}
                                                    onChange={(e) => this.handleContainers(e)}
                                                /></span>
                                            </div>
                                            : null}

                                        {this.state.ReprintTrackingNo ? <div className="col-md-3 mb-3" style={{ "marginTop": "20px" }}>
                                            <label className="catalog-label" htmlFor="cost">Tracking Number</label>
                                            <input type="text" name="RecipientAddress" disabled='true' value={this.state.ReprintTrackingNo} className="form-control" />
                                        </div> : null}
                                        <div className="float-right">
                                            <button className="btn btn-primary custom-btn-primary primary-btn float-left ml-3 px-4" style={{ "marginTop": "48px" }} disabled={!this.state.ReprintTrackingNo} onClick={e => this.ReprintBtnClick(e)}  >Reprint Label</button>
                                        </div>
                                    </div>
                                </div> : <section className="site-undercontruction container text-center center-panel pt-4">
                                        <div className="img-section">
                                            <img src="images/nosearch.jpg" alt="imagefile" />
                                        </div>
                                        <p className="search-result-content pt-4"><Trans>No Records found</Trans>
                                        </p>
                                    </section>}
                            </div>}
                    </div>
                </div>
                <div className="modal" id="PrintPopUp" data-backdrop="static">
                    <div className="modal-dialog modal-md custom-popup modal-dialog-centered">
                        <div className="modal-content">
                            {/* Modal body */}
                            <div className="modal-header">
                                <h4 className="modal-title mt-1">{this.state.ISBOLPrinting ? "Print BOL" : "Print Label"}</h4>
                                <button type="button" className="btn close-btn" data-dismiss="modal" onClick={(e) => this.OkClick(e)}>
                                    X
                             </button>
                            </div>
                            <div className="modal-body dropdown-overlay">
                                <div className="col-md-12 my-2">
                                    <div className="row">
                                        {this.state.PrinterOptions.length > 0 ?
                                            <div className="col-md-12 px-0">
                                                <label className="catalog-label mr-2 mt-2">Printer Types</label>
                                                <div className="col-md-12 mb-3">
                                                    <div style={{ "fontSize": "14px" }}>
                                                        {this.state.ISBOLPrinting ? <Select
                                                            id="BOLPrintID"
                                                            name="BOLPrintID"
                                                            options={this.state.BOLPrinterOptions}
                                                            value={this.state.BOLPrinterValue}
                                                            onChange={(e) => this.handleBOLPrinterChange(e)} /> : <Select
                                                                id="PrinterId"
                                                                name="PrinterId"
                                                                options={this.state.PrinterOptions}
                                                                value={this.state.PrinterValue}
                                                                onChange={(e) => this.handlePrinterChange(e)} />}
                                                    </div>
                                                </div>
                                            </div> : null}
                                        <div className="form-check">
                                            <input className="form-check-input release-notes-checkbox" style={{ top: '2px' }} type="checkbox" id="defaultCheck" name="defaultCheck" checked={this.state.ISBOLPrinting ? this.state.BolDefaultCheck : this.state.DefaultCheck} onChange={(e) => this.onChangeDefaultPrinter(e)} />
                                            <label className="form-check-label release-notes-color release-notes-label ml-1 mt-1 mb-3" htmlFor="defaultCheck">Make Default Printer</label>
                                        </div>
                                        <div className="col-md-12 text-right">
                                            {this.state.ISBOLPrinting ?
                                                <button className="btn btn-secondary custom-btn-secondary secondary-btn px-5" data-dismiss="modal" onClick={(e) => this.CancelBOL(e)}><Trans>Cancel</Trans></button> :
                                                <button className="btn btn-secondary custom-btn-secondary secondary-btn px-5" data-dismiss="modal" onClick={(e) => this.CancelPrint(e)}><Trans>Cancel</Trans></button>}
                                            {this.state.ISBOLPrinting ? <button className="btn btn-primary custom-btn-primary primary-btn ml-3 px-5 " onClick={this.PrintBOL}>Print</button> :
                                                <button className="btn btn-primary custom-btn-primary primary-btn ml-3 px-5 " onClick={this.PrintZebraLabel}>Print</button>}

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal fade wo-details pl-0 show" tabIndex={-1} role="dialog" id="SuccessPop" aria-modal="true" style={{ display: 'block', "marginTop": "173px" }} data-backdrop="static" data-keyboard="false">
                    <div className="modal-dialog modal-lg count-confirm-popup-width" role="document">
                        <div className="modal-content border-0" style={{ width: "89%", "marginTop": "-24px" }}>
                            <div className="modal-header sp-delv-header align-items-center">

                                <h4 className="modal-title mt-1">Shipment Status</h4>
                                <button type="button" className="btn close-btn" data-dismiss="modal" onClick={(e) => this.OkClick(e)}>
                                    X
                             </button>
                            </div>
                            <div className="modal-body">
                                <div className="row justify-content-center">
                                    <div className="col-md-12">
                                        <p className="mb-1 font-18 font-medium">The container has <b>shipped successfully</b>, and the <b>tracking number</b> is generated below.
                                            </p>
                                    </div>


                                    <div className="table-responsive mb-4 popup-grid-scroll-style" style={{ width: "96%", "marginTop": "21px" }}>

                                        <table className="table split-delv-table border-bottom mb-5">
                                            <thead className="sticky-top">
                                                <tr>
                                                    <th>Container ID </th>
                                                    <th>Tracking Number</th>

                                                </tr>
                                            </thead>
                                            <tbody>
                                                {this.bindTrackingNo()}

                                            </tbody>
                                        </table>
                                    </div>
                                </div>


                                <div>
                                    <button className="btn btn-custom-primary font-15 font-medium px-4 py-2" style={{ "marginLeft": "555px" }} onClick={(e) => this.PrintLabel(e)} > Print Label</button>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>

                <div className="modal" id="addattachment" data-backdrop="static">
                    {<div className="modal-dialog modal-md custom-popup modal-dialog-centered">
                        <div className="modal-content">
                            {/* Modal Header */}
                            <div className="modal-header">
                                <h4 className="modal-title mt-1"><Trans>Add Attachment</Trans></h4>
                                <button type="button" className="btn close-btn" data-dismiss="modal" onClick={this.removeMultiImage}>
                                    X
              </button>
                            </div>
                            {/* Modal body */}
                            <div className="modal-body">
                                <div className="row mb-3">
                                    <label className="col-md-5 quick-label"><Trans>Select file to attach</Trans></label>
                                    <div className="col-md-7 mb-0">
                                        <div className="text-left">
                                            <label className="file">
                                                <input type="file" title=" " disabled={this.state.questionCount >= 5} id="WalcartcustomFile" name="filename" aria-label="File browser example" accept="image/jpeg, image/jpg, image/png, image/heic, image/heif" onChange={(e) => this.tempAttach(e)} onClick={this.onInputClick} />
                                                <span className="file-custom" disabled={this.state.questionCount >= 5} />
                                            </label>
                                            {this.bindAttachments()}
                                            <span hidden={this.state.hideOnlyImgMsg} className="float-left err-msg text-danger">You can choose only the image type files!!</span>
                                            <span hidden={this.state.hideDuplicateMsg} className="float-left err-msg text-danger">This image is already uploaded</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-12 mt-2 text-right p-0">
                                    <button className="btn btn-secondary custom-btn-secondary secondary-btn mr-3 px-4" data-dismiss="modal" onClick={() => this.removeMultiImage()}><Trans>Cancel</Trans></button>
                                    <button className="btn btn-primary custom-btn-primary primary-btn px-5" data-dismiss="modal" onClick={(e) => this.addAttachment()} ><Trans>Attach</Trans></button>
                                </div>
                            </div>
                        </div>
                    </div>}

                </div>
            </div>
        );
    }
}
export default withTranslation()(ShippingComponent);